import { faBug } from '@fortawesome/pro-solid-svg-icons/faBug';
import { faLanguage } from '@fortawesome/pro-solid-svg-icons/faLanguage';
import { faLocationPinSlash } from '@fortawesome/pro-solid-svg-icons/faLocationPinSlash';
import { DropdownMenuEntry, useFramework } from '@ukpostbox/frontend-framework';
import React from 'react';
import { useNavigate } from 'react-router';
import { useSite } from '../Providers/SiteInterfaceProvider';

function SiteDevMenu() {
	const navigate = useNavigate();
	const { updateLanguage } = useSite();
	const { UpdateLayoutDirection } = useFramework();

	const UpdateLanguage = (locale: string, rtl: boolean) => {
		UpdateLayoutDirection(rtl ? 'rtl' : 'ltr');
		updateLanguage(locale);
	};

	return (
		<>
			<DropdownMenuEntry icon={faLanguage} title='Languages'>
				<DropdownMenuEntry title='English' onClick={() => UpdateLanguage('en', false)} />
				<DropdownMenuEntry title='日本語' onClick={() => UpdateLanguage('jp', true)} />
				<DropdownMenuEntry title='None' onClick={() => UpdateLanguage('none', false)} />
			</DropdownMenuEntry>
			<DropdownMenuEntry title='Divider' sectionDivider />
			<DropdownMenuEntry title='404' icon={faLocationPinSlash} onClick={() => navigate('/path-to-nowhere')} />
			<DropdownMenuEntry title='Trigger Sentry' icon={faBug} onClick={() => navigate('/error')} />
		</>
	);
}

export { SiteDevMenu };
